import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/long-insure/play.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "table-top" }
const _hoisted_5 = { class: "table" }
const _hoisted_6 = { class: "drawer-contain" }
const _hoisted_7 = { class: "drawer-header" }
const _hoisted_8 = { class: "drawer-header-lt" }
const _hoisted_9 = { class: "drawer-lt-title" }
const _hoisted_10 = { class: "drawer-header-rt" }
const _hoisted_11 = { class: "drawer-rt-btns" }
const _hoisted_12 = { class: "drawer-desc" }
const _hoisted_13 = { class: "descriptions" }
const _hoisted_14 = { class: "cell-item" }
const _hoisted_15 = {
  key: 0,
  class: "cell-item-text"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { key: 2 }
const _hoisted_22 = {
  key: 0,
  class: "left-video-img",
  src: _imports_0,
  alt: ""
}
const _hoisted_23 = {
  key: 1,
  class: "el-icon el-icon-link left-video-img"
}
const _hoisted_24 = ["href"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Back = _resolveComponent("Back")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            inline: true,
            model: _ctx.formSearch,
            class: "demo-form-inline"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formSearch.searchText,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formSearch.searchText) = $event)),
                    placeholder: "请输入出险姓名或身份证",
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.onSearch
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("搜索")
                    ])),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_el_button, { onClick: _ctx.onReset }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("重置")
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onCompanyAdd
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("添加")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createVNode(_component_el_tag, {
        type: "danger",
        effect: "plain",
        style: {"margin-bottom":"16px"}
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode(" 为保障扣费任务顺畅执行，避免案件异常，每晚 23:55:00- 23:59:59期间将暂停新增案件功能，感谢你耐心等待！ ")
        ])),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%","min-height":"500px"},
          "header-cell-style": { background: '#FBFBFD' },
          "header-row-style": { color: '#202536' },
          "row-style": { color: '#5E617D' },
          onSelectionChange: _ctx.handleSelectionChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { label: "出险人姓名" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  type: "text",
                  onClick: ($event: any) => (_ctx.onClickName(scope.row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.outDangerUserName), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "outDangerIdCardNo",
              label: "身份证号码"
            }),
            _createVNode(_component_el_table_column, {
              prop: "companyPlanName",
              label: "保险商品"
            }),
            _createVNode(_component_el_table_column, {
              prop: "outDangerDate",
              label: "出险时间"
            }),
            _createVNode(_component_el_table_column, {
              prop: "outDangerPlace",
              label: "出险地点"
            }),
            _createVNode(_component_el_table_column, {
              prop: "",
              label: "状态"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.formatter(scope.row.reportStatus,_ctx.reportStatusList,{valueKey: 'value'})), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "reportUserName",
              label: "报案人"
            }),
            _createVNode(_component_el_table_column, {
              prop: "createTime",
              label: "报案时间"
            })
          ]),
          _: 1
        }, 8, ["data", "onSelectionChange"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 30, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.initTableList
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showDrawer,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showDrawer) = $event)),
      size: "70%",
      "with-header": false,
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[8] || (_cache[8] = _createTextVNode(" 报案信息 ")),
                _createElementVNode("text", {
                  class: _normalizeClass(['drawer-lt-title-status',`title-status${_ctx.staffBaseInfo.reportStatus}`])
                }, _toDisplayString(_ctx.formatter(_ctx.staffBaseInfo.reportStatus,_ctx.reportStatusList,{valueKey: 'value'})), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: _ctx.goBack
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Back)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "drawer-rt-back" }, null, -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_descriptions, {
                class: "margin-top",
                column: 2,
                size: "default",
                border: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staffColumnItem, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_descriptions_item, { key: index }, {
                      label: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(item.label), 1)
                      ]),
                      default: _withCtx(() => [
                        (item.showType == 'normal')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.staffBaseInfo[item.field]), 1))
                          : _createCommentVNode("", true),
                        (item.showType == 'option')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              (_ctx.staffBaseInfo[item.field] == 'accidentType')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.formatter(_ctx.staffBaseInfo[item.field],_ctx.accidentTypeList,{valueKey: 'value'})), 1))
                                : _createCommentVNode("", true),
                              (_ctx.staffBaseInfo[item.field] == 'hospitalStatus')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.formatter(_ctx.staffBaseInfo[item.field],_ctx.flagList,{valueKey: 'value'})), 1))
                                : _createCommentVNode("", true),
                              (_ctx.staffBaseInfo[item.field] == 'hurtStatus')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.formatter(_ctx.staffBaseInfo[item.field], _ctx.superHurtTypeList,{valueKey: 'value'})), 1))
                                : _createCommentVNode("", true),
                              (_ctx.staffBaseInfo[item.field] == 'isUploaded')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.formatter(_ctx.staffBaseInfo[item.field],_ctx.isUploadedList,{valueKey: 'value'})), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (item.showType == 'video')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staffBaseInfo.fileUrl, (itm, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "left-video",
                                  key: index
                                }, [
                                  (itm.fileType === 'video')
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                                    : (_openBlock(), _createElementBlock("i", _hoisted_23)),
                                  _createElementVNode("a", {
                                    class: "left-video-a",
                                    target: "_blank",
                                    href: itm.fileUrl
                                  }, "员工出险" + _toDisplayString(itm.fileType === 'video' ? '视频' : '照片'), 9, _hoisted_24)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (item.showType == 'idCardNo')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 3,
                              onClick: ($event: any) => (_ctx.onClickCardNo(_ctx.staffBaseInfo[item.field],item.field)),
                              style: {"cursor":"pointer"}
                            }, _toDisplayString(_ctx.cardNumShow ? _ctx.staffBaseInfo.outDangerIdCardNo : _ctx.staffBaseInfo.cardNumber), 9, _hoisted_25))
                          : _createCommentVNode("", true),
                        (item.showType == 'childObj')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.userPlanInfo[item.field]), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (item.showType == 'time')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.userPlanInfo.insureStartTime) + "-" + _toDisplayString(_ctx.checkInsureEndTime(_ctx.userPlanInfo.insureEndTime)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}